__turbopack_context__.v({
  "className": "caveat_7f18ce09-module__8O7OSW__className",
  "variable": "caveat_7f18ce09-module__8O7OSW__variable",
});
